import React, { useCallback } from 'react';
import styled                 from 'styled-components';
import { useField }           from 'formik';
import { EAudience }          from '@enums/auction';

interface IStyledProps {
  selected: boolean;
}

const TabsWrapper = styled.div`
  width      : 100%;
  display    : flex;
  margin-top : 10px;

  margin-bottom: ${({ theme: { width } }: any): string =>
    ((width === 'lg' || width === 'xl') ? '32px' : '25px')};

  > div {
    width       : 50%;
    text-align  : center;
    white-space : nowrap;
    height      : 32px;
    padding     : 6px;
    border      : 1px solid ${({ theme: { borderColor } }): string => borderColor.blue};
  }

  div:first-child {
    border-radius: 5px 0 0 5px;
  }

  div:last-child {
    border-radius: 0 5px 5px 0;
  }
`;

const Tab = styled.div<IStyledProps>`
  font-size      : 16px;
  cursor         : pointer;
  height         : 35px;
  padding-top    : 8px;
  padding-bottom : 10px;

  color: ${({ selected, theme: { textColor } }: any): string => (
    selected ? textColor.white : textColor.blue)};

  background-color: ${({ selected, theme: { backgroundColor } }: any): string => (
    selected ? backgroundColor.blue : backgroundColor.white)};
`;

interface IProps {
  name      : string;
  disabled? : boolean;
}

export const DoubleButton: React.FC<IProps> = ({
  name,
  disabled,
}) => {
  const [field, , helpers] = useField<EAudience>(name);

  const onChange = useCallback(
    (value: EAudience) => {
      if (disabled) {
        return;
      }

      helpers.setValue(value);
    },
    [disabled, helpers],
  );

  return (
    <TabsWrapper>
      <Tab
        selected = {field.value === EAudience.DealerAndPublic}
        onClick  = {(): void => onChange(EAudience.DealerAndPublic)}
      >
        Dealers and the Public
      </Tab>
      <Tab
        selected = {field.value === EAudience.DealerOnly}
        onClick  = {(): void => onChange(EAudience.DealerOnly)}
      >
        Dealers Only
      </Tab>
    </TabsWrapper>
  );
};
